import { pages } from '../util/global-methods'
import { deployEnv } from '~/config'

const routes = [
  {
    path: 'account',
    component: pages('mypage'),
    meta: { auth: true },
    children: [
      // {
      //   path: '',
      //   redirect: 'account/dashboard',
      // },
      // {
      //   path: 'dashboard',
      //   component: pages('mypage/main'),
      //   props: true,
      //   meta: {name: 'dashboard'}
      // },
      // {
      //   path: 'push-notification',
      //   component: pages('mypage/push-notification'),
      //   props: true,
      //   meta: {name: 'push-notification'}
      // },
      {
        path: 'order-history',
        component: pages('mypage/order-history'),
        name: 'order-history',
        props: true,
        meta: { name: 'order-history' },
      },
      {
        path: 'order-details/:orderId',
        component: pages('mypage/order-details'),
        props: true,
        meta: { name: 'order-details' },
      },
      {
        path: 'order-cancellation-refund',
        name: 'orderCancel',
        component: pages('mypage/order-cancellation-refund'),
        props: true,
        meta: { name: 'order-cancellation-refund' },
      },
      {
        path: 'order-cancellation-refund-history',
        component: pages('mypage/order-cancellation-refund-list'),
        props: true,
        meta: { name: 'order-cancellation-refund-history' },
      },
      {
        path: 'order-cancellation-refund-detail/:orderId',
        component: pages('mypage/order-cancellation-refund-detail'),
        props: true,
        meta: { name: 'order-cancellation-refund-detail' },
      },
      {
        path: '',
        component: pages('mypage/coupon'),
        props: true,
        redirect: 'coupon/mycoupon',
        meta: {
          auth: true,
        },
        children: [
          {
            path: 'coupon-list',
            component: pages('mypage/coupon/types/mycoupon'),
            props: true,
            meta: { name: 'coupon-list' },
          },
          {
            path: 'new-coupon-list',
            component: pages('mypage/coupon/types/newcoupon'),
            props: true,
            meta: { name: 'new-coupon-list' },
          },
        ],
      },
      {
        path: 'wishlist',
        component: pages('mypage/wishlist'),
        props: true,
        meta: { name: 'wishlist' },
      },
      {
        path: 'content',
        component: pages('mypage/content'),
        props: true,
        redirect: 'content/qna',
        meta: { auth: true },
        children: [
          // {path: 'inquiry', component: pages('mypage/content/types/inquiry'), props: true, meta: {name: 'inquiry'}},
          // {path: 'chat', component: pages('mypage/content/types/chat'), props: true, meta:{ name: 'chat' },},
          {
            path: 'qna',
            component: pages('mypage/content/types/qna'),
            props: true,
            meta: { name: 'qna', allow: true },
          },
          {
            path: 'review',
            component: pages('mypage/content/types/review'),
            props: true,
            meta: { name: 'review' },
          },
        ],
      },
      // {path: 'profile', component: pages('mypage/profile'), props: true, meta: {name: 'profile'}},
      // {path: 'user-details', component: pages('mypage/user-details'), props: true, meta: {name: 'user-details'}},
      // {path: 'delete', component: pages('mypage/user-withdrawal'), props: true, meta: {name: 'delete'}},
      // {
      //   path: 'subscription',
      //   component: pages('mypage/profile/subscription'),
      //   props: true,
      //   meta: {name: 'subscription'}
      // },
      // {
      //   path: 'social-networks',
      //   component: pages('mypage/profile/social-networks'),
      //   props: true,
      //   meta: {name: 'social-networks'}
      // },
      // {
      //   path: '', component: pages('mypage/myactivity'), props: true, redirect: 'myactivity/loginlog',
      //   children: [
      //     {
      //       path: 'signin-history',
      //       component: pages('mypage/myactivity/types/login-log'),
      //       props: true,
      //       meta: {name: 'signin-history'}
      //     },
      //     {
      //       path: 'activity-history',
      //       component: pages('mypage/myactivity/types/edit-log'),
      //       props: true,
      //       meta: {name: 'activity-history'}
      //     }
      //   ]
      // },
      // {
      //   path: '', component: pages('mypage/privacy'), props: true,
      //   children: [
      //     {
      //       path: 'privacy-policy-history',
      //       component: pages('mypage/privacy/types/usage'),
      //       props: true,
      //       meta: {name: 'privacy-policy-history'}
      //     },
      //     {
      //       path: 'third-party-privacy-policy-history',
      //       component: pages('mypage/privacy/types/offer'),
      //       props: true,
      //       meta: {name: 'third-party-privacy-policy-history'}
      //     },
      //     {
      //       path: 'personal-information-handling-and-management-policy-history',
      //       component: pages('mypage/privacy/types/consignment'),
      //       props: true,
      //       meta: {name: 'personal-information-handling-and-management-policy-history'}
      //     },
      //   ]
      // }
    ],
  },
  {
    path: 'account/voucher',
    name: 'voucher',
    component: pages('mypage/voucher'),
    props: true,
    meta: { layout: 'blank', name: 'voucher' },
    query: { id: null, hnt_uid: null },
  },
  {
    path: 'voucher/email',
    name: 'voucherEmail',
    component: pages('mypage/voucher'),
    props: true,
    meta: { layout: 'blank', name: 'voucher', auth: true, voucherEmail: true },
    query: { id: null, pricingId: null },
  },
  {
    path: 'account/voucher-preview',
    name: 'voucherPreview',
    component: pages('mypage/voucher'),
    props: true,
    meta: { layout: 'blank', name: 'voucher' },
    query: { id: null },
  },
]

if (deployEnv === 'dev') {
  routes[0].children.push({
    path: 'order-details/markup/:orderId',
    component: pages('mypage/order-details/markup'),
    props: true,
    meta: { name: 'order-details-markup' },
  })
}

export default routes.map((route) => ({
  ...route,
  meta: { ...route.meta, noindex: true },
}))
